import { icons } from "../../helpers/constants";

const DeviceSelectionRowNew = ({ selectable = true, selected, index, onClick, text, subtitle, subtitle2, dividerColor = "bg-light-grey", last = false, radio = false }) => {
    return (
        <>
        <div className="d-flex flex-column">
            <div className="d-flex align-items-center justify-content-between w-100 py-2 px-3" onClick={() => onClick()}>
                <div className="d-flex flex-column py-1 w-75">
                    <p className=" primary m-0 bold text-truncate">{text}</p>
                    <p className={`primary m-0 ${subtitle ? "" : "d-none"}`}>{subtitle}</p>
                    <p className={`primary m-0 ${subtitle2 ? "" : "d-none"}`}>{subtitle2}</p>

                </div>
                {selectable
                    ?
                    <div className={`checkbox-${selected ? "active" : "inactive"} rounded8 size_20 d-flex justify-content-center p-1 cursor-pointer`}>
                        {selected && <img className="white-icon" src={icons.check} alt={""} />}
                    </div>
                    :
                    <img className="cursor-pointer primary-icon" src={icons.info_icon} alt={""} />
                }
            </div>
        </div>
        {!last && 
            <div className={`m-0 p-0 event-divider ${dividerColor}`} />
        }
        </>
    )
}

export default DeviceSelectionRowNew;